import React, { Component } from "react";
import PropTypes from "prop-types";
import InputTrigger from "react-input-trigger";
import "./RichTextInputField.css";
import matchPhrase from '../words';
import FakeData from "../fake-data";
import Ionicon from 'react-ionicons';

export default class RichTextInputField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			content: props.value,
			isEmoji: false,
			isError: false,
			errorWords: [],
			top: null,
			left: null,
			showSuggestor: false,
			filter: "",
			currentSelection: false,
			startPosition: null,
			rawText: ""
		};

		this.toggleSuggestor = this.toggleSuggestor.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.onTextChange = this.onTextChange.bind(this);
	}

	handleKeyDown(event) {
		const { which } = event;
		const { currentSelection, startPosition, content, rawText } = this.state;
		const { friends } = FakeData.getData("yoo");

		if (which === 40) {
			// 40 is the character code of the down arrow
			event.preventDefault();

			this.setState({
				currentSelection:
					(currentSelection + 1) % FakeData.listify(friends).length
			});
		}

		if (which === 13) {
			// 13 is the character code for enter
			event.preventDefault();
			if (!this.state.currentSelection) {

			} else {
				const user = FakeData.listify(friends)[currentSelection];
				const newText = `${content.slice(0, startPosition - 1)}${
					user.name
					}${content.slice(startPosition + user.name.length, content.length)}`;
				const newRawText = `${rawText.slice(0, startPosition - 1)}${"%" +
					user.id +
					"^" +
					user.type +
					"%"}${rawText.slice(
						startPosition + ("%" + user.id + "^" + user.type + "%").length,
						rawText.length
					)}`;
				const newRawHtml = `${rawText.slice(
					0,
					startPosition - 1
				)}${'<a href="/profile/' +
				user.user +
				'?sInit=about">' +
				user.name +
				"</a>"}${rawText.slice(
					startPosition +
					('<a href="/profile/' + user.user + '">' + user.name + "</a>").length,
					rawText.length
				)}`;

				this.setState({
					showSuggestor: false,
					left: null,
					top: null,
					filter: "",
					currentSelection: false,
					startPosition: null,
					content: newText,
					rawText: newRawText,
					rawHTML: newRawHtml
				});

				if (this.props.onRawTextChange) {
					const _that = this;
					if (this.props.usersOnly) {
						const matches = newRawText.match(/%(.*?)%/g);
						const finalRawString = FakeData.listify(matches).join(",");
						this.props.onRawTextChange(newText, finalRawString)
					} else {
						this.props.onRawTextChange(newText, newRawText)
					}
					//this.props.onRawTextChange(newText, newRawText);
					if (this.props.onKeyUp) {
						setTimeout(() => {
							_that.props.onKeyUp(event, newText, newRawText)
						}, 1500)
					}
				}

				this.endHandler();
			}
		}
	}

	userClick = (user) => {
		if (!this.state.currentSelection) {

		} else {
			const { currentSelection, startPosition, content, rawText } = this.state;
			const newText = `${content.slice(0, startPosition - 1)}${
				user.name
				}${content.slice(startPosition + user.name.length, content.length)}`;
			const newRawText = `${rawText.slice(0, startPosition - 1)}${"%" +
				user.id +
				"^" +
				user.type +
				"%"}${rawText.slice(
					startPosition + ("%" + user.id + "^" + user.type + "%").length,
					rawText.length
				)}`;
			const newRawHtml = `${rawText.slice(
				0,
				startPosition - 1
			)}${'<a href="/profile/' +
			user.user +
			'?sInit=about">' +
			user.name +
			"</a>"}${rawText.slice(
				startPosition +
				('<a href="/profile/' + user.user + '">' + user.name + "</a>").length,
				rawText.length
			)}`;

			this.setState({
				showSuggestor: false,
				left: null,
				top: null,
				filter: "",
				startPosition: null,
				content: newText,
				currentSelection: false,
				rawText: newRawText,
				rawHTML: newRawHtml
			});

			if (this.props.onRawTextChange) {
				if (this.props.usersOnly) {
					const matches = newRawText.match(/%(.*?)%/g);
					const finalRawString = FakeData.listify(matches).join(",");
					this.props.onRawTextChange(newText, finalRawString)
				} else {
					this.props.onRawTextChange(newText, newRawText)
				}
			}

			this.endHandler();
		}
	}

	emojiInsert = (e) => {
		const { currentSelection, startPosition, content, rawText } = this.state;
		const newContent = `${content}${e}`;
		const newRawHtml = `${rawText}${e}`;
		this.setState({
			showSuggestor: false,
			left: null,
			top: null,
			filter: "",
			startPosition: null,
			content: newContent,
			currentSelection: false,
			rawText: newRawHtml
		});

		if (this.props.onRawTextChange) {
			if (this.props.usersOnly) {
				const matches = newRawHtml.match(/%(.*?)%/g);
				const finalRawString = FakeData.listify(matches).join(",");
				this.props.onRawTextChange(newContent, finalRawString)
			} else {
				this.props.onRawTextChange(newContent, newRawHtml)
			}
		}
	}

	toggleSuggestor(metaInformation) {
		const { hookType, cursor } = metaInformation;

		if (hookType === "start") {
			this.setState({
				showSuggestor: true,
				left: cursor.left,
				startPosition: cursor.selectionStart,
				top: cursor.top + cursor.height + 20 // we need to add the cursor height so that the dropdown doesn't overlap with the `@`.
			});
		}

		if (hookType === "cancel") {
			// reset the state

			this.setState({
				showSuggestor: false,
				left: null,
				top: null,
				startPosition: null
			});
		}
	}

	handleInput(metaInformation) {
		this.setState({
			filter: metaInformation.text
		});
	}

	onTextChange = e => {
		const { friends } = FakeData.getData("yoo");
		const ma = matchPhrase({
			phrase: e.target.value,
			local_list: []
		})
		if (this.props.onTextChange && ma.matchedList.length===0) {
			this.props.onTextChange(e, (ma.matchedList.length>0?true:false));
		}

		let rawText = FakeData.nullify(e.target.value);
		FakeData.listify(friends).forEach((item, i) => {
			const _content = "%" + item.id + "^" + item.type + "%";
			rawText = rawText.replace(item.name, _content);
			rawText = rawText.replace("@", "");
		})

		if (this.props.onRawTextChange) {
			if (this.props.usersOnly) {
				const matches = rawText.match(/%(.*?)%/g);
				const finalRawString = FakeData.listify(matches).join(",");
				this.props.onRawTextChange(e.target.value, finalRawString, (ma.matchedList.length>0?true:false))
			} else {
				this.props.onRawTextChange(e.target.value, rawText, (ma.matchedList.length>0?true:false))
			}
		}

		this.setState({ content: e.target.value, rawText: rawText, isError: ma.matchedList.length>0?true:false, errorWords: ma.matchedList });
	};

	render() {
		const { placeholder, disabled } = this.props;
		const { friends } = FakeData.getData("yoo");
		const { filter, isEmoji } = this.state;
		return (
			<div
				className={"rich-text-input"}
				onKeyDown={this.handleKeyDown}
				style={{
					flex: this.props.noStyle ? "" : 1,
					display: 'flex',
					flexDirection: 'column',
					padding: '10px 0px'
				}}
			>
				<InputTrigger
					trigger={{
						keyCode: 50,
						shiftKey: true
					}}
					onStart={metaData => {
						this.toggleSuggestor(metaData);
					}}
					onCancel={metaData => {
						this.toggleSuggestor(metaData);
					}}
					onType={metaData => {
						this.handleInput(metaData);
					}}
					endTrigger={endHandler => {
						this.endHandler = endHandler;
					}}
				>
					<textarea
						value={this.state.content}
						disabled={disabled}
						className={this.state.isError?"error":""}
						style={{
							width: this.props.noStyle ? "" : "100%",
							...this.props.textAreaStyle
						}}
						placeholder={placeholder ? placeholder : "Write something..."}
						onChange={(e) => {
							const { value } = e.target;
							const { matchedList } = matchPhrase({phrase:value});
							this.onTextChange(e);
						}}
						onKeyPress={this.props.onKeyPress}
						onKeyUp={this.props.onKeyUp}
					/>
				</InputTrigger>
				<div className={"error-words"} style={{
					padding: '0px 20px'
				}}>
					{this.state.errorWords.length === 0 ? "" : this.props.onKeyPress ? "" : "Remove the following words"}
					{!this.props.onKeyPress &&
						this.state.errorWords.map((w, i) => {
							return (
								<span key={w} style={{
									margin: '0px 5px',
									padding: 5,
									background: '#4ac',
									color: '#fff'
								}}>{w}</span>
							)
						})
					}
				</div>
				{/*this.props.type && this.props.type === 'emoji' &&
					<div style={{
						display: 'flex',
						alignItems: 'flex-end'
					}}>
						<FakeData.EmojiMart.Picker onSelect={(e) => {
							//console.log(e)
							this.emojiInsert(e.native)
						}} showPreview={false} color="#4ac" style={{ position: 'absolute', display: isEmoji ? "" : "none", right: '20px', top: '100%', zIndex: 10000 }} />
						<Ionicon icon={"md-happy"} color={isEmoji ? "#4ac" : "#345"} fontSize="20px" style={{
							width: "25px",
							height: "25px",
							margin: "0px 10px",
						}} onClick={() => {
							this.setState({ isEmoji: !isEmoji });
						}} />
					</div>*/
				}
				<div
					id="dropdown"
					key={filter}
					style={{
						position: "absolute",
						width: "200px",
						borderRadius: "2px",
						background: "white",
						boxShadow: "rgba(0, 0, 0, 0.4) 0px 1px 4px",
						minHeight: "100px",
						zIndex: 99909,
						display: this.state.showSuggestor ? "block" : "none",
						top: this.state.top,
						left: this.state.left
					}}
				>
					{FakeData.listify(friends)
						.filter((user, i) => {
							return (
								FakeData.nullify(user.name)
									.toLowerCase()
									.indexOf(filter.toLowerCase()) > -1
							);
						})
						.map((user, index) => (
							<div
								key={user.id}
								onClick={() => {
									this.userClick(user)
								}}
								style={{
									padding: "10px 20px",
									background:
										index === this.state.currentSelection ? "#eee" : ""
								}}
							>
								{user.name}
							</div>
						))}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/RichTextInputField.jsx